<template>
    <div />
</template>

<script lang="ts" setup>
import axios from 'axios'
const config = useRuntimeConfig()
const route = useRoute()
definePageMeta({
  layout: 'public'
})

onMounted(async () => {
  const { code } = route.query || {}
  const { app } = route.params || {}
  if (window.opener) {
    switch (app) {
    case 'freightek':
      await freightekAuth(code as string)
      break
    }
    window.close()
  }
})
const freightekAuth = async (code: string) => {
  const ftConfig = config.public.appConfigs?.freightek
  const response = await axios.post(ftConfig.accountHost + '/oauth/token', {
    grant_type: 'authorization_code',
    client_id: ftConfig.clientId,
    client_secret: ftConfig.clientSecret,
    redirect_uri: `${window.location.origin}/auth/callback-freightek`,
    code
  })
  const authData = response.data || {}
  window.opener.postMessage(authData, window.origin)
}
</script>
